// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__moMtY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__295hv"};